// extracted by mini-css-extract-plugin
export default {"title":"ContactMe_title__jQpPQ","platforms":"ContactMe_platforms__aBo1p","heading":"ContactMe_heading__CBozF","icon":"ContactMe_icon__d-xTB","section":"ContactMe_section__193ms"};